import { Expose, plainToInstance, Type } from "class-transformer";

import { PostActionTypeEnum, PostType } from "../../../types";
import { PostActionModel } from "../PostActionModel";
import { PostMessage } from "../PostMessage";

export default class EditPostActionModel extends PostActionModel {
    type = PostActionTypeEnum.EditPostAction;

    @Type(() => PostMessage)
    @Expose({ name: 'message' })
    private _message: PostMessage = plainToInstance(PostMessage, {
        type: PostType.Post,
        variants: [ {
            'pin': false,
            'text': '',
            'buttons': [],
            'disable_notify': false,
            'remove_previous': false,
            'disable_link_preview': false,
            'attachments': [],
            'send_after': 0,
            'remove_after': 0,
            'protect_content': false
        } ]
    })

    get message(): PostMessage {
        return this._message;
    }

    set message(value: PostMessage | any) {
        if (value instanceof PostMessage) {
            this._message = value;
        } else {
            this._message = plainToInstance(PostMessage, value);
        }
    }
}
